import React from 'react';
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { injectIntl } from "react-intl";
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';


const effectTypes = [
    { value: 'noeffect', display: 'There is no effect on the Accepted Programme' },
    { value: 'mitigated', display: 'There is an effect on the Accepted Programme but this has been mitigated by measures as detailed' },
    { value: 'notmitigated', display: 'There is an effect on the Accepted Programme which we are unable to mitigate' },
];
const effectTypesNoProgramReply = [
    { value: 'noeffect', display: 'There is no effect on the Programme' },
    { value: 'mitigated', display: 'There is an effect on the Programme but this has been mitigated by measures as detailed' },
    { value: 'notmitigated', display: 'There is an effect on the Programme which we are unable to mitigate' },
]

class QuoteDocument extends BaseDocument {
    constructor(props) {
        super(props);
        this.validatorRef = props.validatorRef ? props.validatorRef : React.createRef();

        if (props.programmeReplyEnabled) {
            this.effectTypes = effectTypes;
        }
        else {
            this.effectTypes = effectTypesNoProgramReply;
        }

        this.isAsiteEnabled = process.env.REACT_APP_ASITE_ENABLED === 'true';
    }

    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        if (field) {
            if (this.props.valueChangeHandler) {
                this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
            }
        }
    }

    calculateTotal = (obj) => {
        const prc1 = obj.totallistprice ? obj.totallistprice : 0;
        const prc2 = obj.totalassessed ? obj.totalassessed : 0;
        return prc1 + prc2;
    }

    renderForm = () => {
        const { fields } = this.props.workflowItem;

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { label: fields.Subject.label, dataField: 'subject', editorOptions: { readOnly: true } }
            ]
        };

        if (this.props.resources.QuoteNoteRequestForQuote) {
            createFormConfig.fields.push(
                { note: this.props.resources.QuoteNoteRequestForQuote.replace('$reference', this.props.requestForQuote.referenceid), valueType: 'NOTE' },
            );
        }

        if (fields.Description.visible) {
            createFormConfig.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor', editorOptions: { readOnly: true } })
        }
        if (fields.Comments.visible) {
            createFormConfig.fields.push({ label: fields.Comments.label, dataField: 'comments', editorType: 'dxHtmlEditor' })
        }
        if (fields.ItemsList.visible) {
            createFormConfig.fields.push({ label: fields.ItemsList.label, dataField: 'itemslist' })
        }
        if (fields.TotalListPrice.visible) {
            createFormConfig.fields.push({ label: fields.TotalListPrice.label, dataField: 'totallistprice', editorType: 'dxNumberBox' })
        }
        if (fields.RequestForQuoteDescription.visible) {
            createFormConfig.fields.push({ label: fields.RequestForQuoteDescription.label, dataField: 'requestforquotedescription' })
        }
        if (fields.TotalAssessed.visible) {
            createFormConfig.fields.push({ label: fields.TotalAssessed.label, dataField: 'totalassessed', editorType: 'dxNumberBox' })
        }
        if (fields.TotalPrice.visible) {
            createFormConfig.fields.push({ label: fields.TotalPrice.label, dataField: 'totalprice', editorType: 'dxNumberBox', value: this.calculateTotal })
        }
        if (fields.StartDate.visible) {
            var startDateField = { label: fields.StartDate.label, dataField: 'startdate', editorType: 'dxDateBox' };

            if (this.props.configurableRFQFields.StartDate) {
                startDateField = { label: fields.StartDate.label, dataField: 'startdate', editorType: 'dxDateBox', editorOptions: { readOnly: true } };
            }

            if (fields.CompletionDate.visible) {
                startDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.completiondate >= value), warning: 'Completion date can not be earlier than start date' }
            }

            createFormConfig.fields.push(startDateField);
        }
        if (fields.CompletionDate.visible) {
            var completionDateField = { label: fields.CompletionDate.label, dataField: 'completiondate', editorType: 'dxDateBox' }

            if (this.props.configurableRFQFields.CompletionDate) {
                completionDateField = { label: fields.CompletionDate.label, dataField: 'completiondate', editorType: 'dxDateBox', editorOptions: { readOnly: true } }
            }

            if (fields.StartDate) {
                completionDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.startdate <= value), warning: 'Completion date can not be earlier than start date' }
            }

            createFormConfig.fields.push(completionDateField);
        }
        if (fields.DelayAmount.visible) {
            if (this.props.configurableRFQFields.DelayAmount) {
                createFormConfig.fields.push({ label: fields.DelayAmount.label, dataField: 'delayamount', required: false, editorType: 'dxNumberBox', editorOptions: { readOnly: true } })
            } else {
                createFormConfig.fields.push({ label: fields.DelayAmount.label, dataField: 'delayamount', required: false, editorType: 'dxNumberBox' })
            }
        }
        if (fields.DelayPaymentPeriod.visible) {
            if (this.props.configurableRFQFields.DelayPaymentPeriod) {
                createFormConfig.fields.push({ label: fields.DelayPaymentPeriod.label, dataField: 'delaypaymentperiod', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.DelayPaymentPeriod.paymentPeriods, readOnly: true } })
            } else {
                createFormConfig.fields.push({ label: fields.DelayPaymentPeriod.label, dataField: 'delaypaymentperiod', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.DelayPaymentPeriod.paymentPeriods } })
            }
        }

        return (
            <BiDynamicForm
                validatorRef={this.validatorRef}
                item={this.props.notification}
                config={createFormConfig}
                onSubmitHandler={null}
                valueChangeHandler={this.fieldChanged}
                customFields={(this.props.customFieldsCommon || {}).RFQQUOTE}
            />
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType, this.props.notification.rfqquotationid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }


    render() {

        const documentIsFinal = this.props.notification.showtasknotification === 1;
        const { createby, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={createby}
                    createdate={createdate}
                    lastdraftedbyname={lastdraftedbyname}
                    lastdrafteddate={lastdrafteddate}
                    lastdraftednotifiedtoname={lastdraftednotifiedtoname}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.requestforquotereference}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    customFields={(this.props.customFieldsCommon || {}).RFQQUOTE}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.requestForQuote.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                    quoteref={this.props.notification.referenceid}
                />

            </>

        );
    }
}

export default injectIntl(QuoteDocument);
